import { render, staticRenderFns } from "./DataBuildAccountAllocationCampaigns.vue?vue&type=template&id=3832bbf8&scoped=true"
import script from "./DataBuildAccountAllocationCampaigns.vue?vue&type=script&lang=js"
export * from "./DataBuildAccountAllocationCampaigns.vue?vue&type=script&lang=js"
import style0 from "./DataBuildAccountAllocationCampaigns.vue?vue&type=style&index=0&id=3832bbf8&prod&scoped=true&lang=css"
import style1 from "./DataBuildAccountAllocationCampaigns.vue?vue&type=style&index=1&id=3832bbf8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3832bbf8",
  null
  
)

export default component.exports